import React, { useEffect, useState } from 'react'
import TouchEditorMethods, { ITouchEditorProps } from './touchEditor.local.methods'
import TouchEditorActions from './__actions/touchEditor__actions'
import TouchEditorEvents from './__events/touchEditor__events'
import Modal from 'blocks.simple/modal/modal'
import Rectangle from 'blocks.simple/rectangle/rectangle'
import Button from 'blocks.simple/button/button'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './touchEditor.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { IEvent } from '../../pages/broadcasts/_broadcastEvents/broadcastEvents'
import { api } from '../../core/api/ConnectionManager'

const TouchEditor = (p_: ITouchEditorProps) => {
    const [activeTab, setActiveTab] = useState<string>('createEvent')
    const [eventsList, setEventsList] = useState<IEvent[]>([])
    const { state, actionsRef, eventsRef, onSave } = TouchEditorMethods(p_)
    const s_ = state

    const getPriorityValueToString = (value: number) => {
        switch (value) {
            case 0:
                return 'low'
            case 1:
                return 'medium'
            case 2:
                return 'high'
            default:
                return ''
        }
    }

    useEffect(() => {
        api.send('getBroadcastEvents', { limit: 1000 }).then((res: any) => {
            if (res && res.data) {
                setEventsList(res.data)
            }
        })
    }, [])

    return (
        <Modal open={p_.open} showCloseIcon={false} mod={'clear'}>
            <div className={styles.modalWrapper}>
                <div className={styles.modalInner}>
                    <div className={cn(grid.col, styles.innerWrapper)}>
                        {p_.onSelectEvent && p_.createMode && (
                            <div className={styles.tabs}>
                                <div
                                    className={cn(styles.tab, activeTab === 'createEvent' ? styles.activeTab : '')}
                                    onClick={() => setActiveTab('createEvent')}
                                >
                                    {translate('createEvent')}
                                </div>
                                <div
                                    className={cn(styles.tab, activeTab === 'selectFromList' ? styles.activeTab : '')}
                                    onClick={() => setActiveTab('selectFromList')}
                                >
                                    {translate('selectFromList')}
                                </div>
                            </div>
                        )}
                        {activeTab === 'createEvent' && (
                            <>
                                <div className={styles.wrapper}>
                                    <div className={styles.header}>
                                        {p_.type === 'content'
                                            ? translate('actionSettingsForContent')
                                            : translate('eventSettingsForPage')}
                                    </div>
                                    <div className={styles.settings}>
                                        {p_.type === 'content' && s_.actions.length > 0 && (
                                            <TouchEditorActions
                                                content={p_.content}
                                                pages={p_.pages}
                                                page={p_.page}
                                                action={p_.action}
                                                actions={s_.actions}
                                                actionsRef={actionsRef}
                                            />
                                        )}
                                        {p_.type === 'content' && !s_.actions.length && (
                                            <div className={styles.emptyMessage}>{translate('noActionAvailable')}</div>
                                        )}
                                        {p_.type === 'page' && s_.events.length > 0 && (
                                            <TouchEditorEvents
                                                pages={p_.pages}
                                                page={p_.page}
                                                event={
                                                    p_.event || {
                                                        id: '',
                                                        eventType: '',
                                                        eventCondition: { key: '', value: '' },
                                                    }
                                                }
                                                events={s_.events}
                                                eventsRef={eventsRef}
                                            />
                                        )}
                                        {p_.type === 'page' && !s_.events.length && (
                                            <div className={styles.emptyMessage}>{translate('noEventsAvailable')}</div>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.footer}>
                                    <Button onClick={p_.onClose} className={grid.mr_mini}>
                                        {translate('close')}
                                    </Button>
                                    {p_.type === 'content' && s_.actions.length > 0 && (
                                        <Button
                                            onClick={() => {
                                                setActiveTab('createEvent')
                                                onSave()
                                            }}
                                            mod={'fill'}
                                        >
                                            {translate('save')}
                                        </Button>
                                    )}
                                    {p_.type === 'page' && s_.events.length > 0 && (
                                        <Button
                                            onClick={() => {
                                                setActiveTab('createEvent')
                                                onSave()
                                            }}
                                            mod={'fill'}
                                        >
                                            {translate('save')}
                                        </Button>
                                    )}
                                </div>
                            </>
                        )}
                        {activeTab === 'selectFromList' && (
                            <>
                                <div style={{ overflow: 'auto' }}>
                                    <div className={styles.header}>{translate('selectFromList')}</div>
                                    <div className={styles.eventsList}>
                                        <table className={styles.table}>
                                            <tbody>
                                                <tr>
                                                    <th className={styles.cell}>{translate('name')}</th>
                                                    <th className={styles.cell}>{translate('eventType')}</th>
                                                    <th className={styles.cell}>{translate('key')}</th>
                                                    <th className={styles.cell}>{translate('value')}</th>
                                                    <th className={styles.cell}>{translate('priority')}</th>
                                                </tr>
                                                {eventsList.map((event) => {
                                                    return (
                                                        <tr
                                                            key={event.id}
                                                            className={styles.row}
                                                            onClick={() => {
                                                                const id = event.id

                                                                if (id && p_.onSelectEvent) {
                                                                    setActiveTab('createEvent')
                                                                    p_.onSelectEvent({ id, name: event.name })
                                                                }
                                                            }}
                                                        >
                                                            <td className={styles.cell}>{event.name}</td>
                                                            <td className={styles.cell}>
                                                                {translate(event.eventType || '')}
                                                            </td>
                                                            <td className={styles.cell}>
                                                                {translate(`${event.eventType}_${event.key}`)}
                                                            </td>
                                                            <td className={styles.cell}>
                                                                {event.conditionList && event.conditionList.length
                                                                    ? event.conditionList[0].value
                                                                    : event.condition?.value}
                                                            </td>
                                                            <td className={styles.cell}>
                                                                {translate(
                                                                    getPriorityValueToString(event.priority) +
                                                                        'Priority'
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className={styles.close}>
                                    <Button onClick={p_.onClose} mod={'fill'}>
                                        {translate('close')}
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

TouchEditor.defaultProps = {
    open: false,
    onClose: () => {},
}

export default TouchEditor
